import { Checkbox } from "@/components/generic/Checkbox";
import { Label, Text, type CheckboxProps } from "react-aria-components";
import { useController, type Control, type Path } from "react-hook-form";
import { twMerge } from "tailwind-merge";

export interface CheckCardProps<T extends object> extends Omit<
  CheckboxProps,
  "name" | "className"
> {
  label: string;
  control?: Control<T>;
  name: Path<T>;
  className?: string;
}

export function CheckCard<T extends object>({
  children,
  control,
  label,
  name,
  className,
  ...props
}: CheckCardProps<T>) {
  const { field } = useController({
    control: control ?? undefined,
    name,
  });

  return (
    <Label
      key="deliver-live-number"
      className={twMerge(
        "border-theme-outline-variant hover:bg-theme-on-background/3 flex w-full cursor-pointer items-center rounded-sm border transition-colors",
        props.isDisabled &&
          "cursor-not-allowed opacity-50 hover:bg-transparent",
        className,
      )}
    >
      <div className="border-theme-outline-variant shrink-0 border-r p-3">
        <Checkbox
          value={props.value}
          // TODO - MWK: this is a quick fix to handle "checkbox" input in exportinput
          isSelected={field.value === "true" || field.value === true}
          onChange={(checked) => {
            field.onChange(
              typeof field.value === "string"
                ? checked
                  ? "true"
                  : "false"
                : checked,
            );
          }}
          isDisabled={props.isDisabled}
        />
      </div>
      <div className="p-4">
        <Text className="text-theme-on-glass text-[11px] font-medium text-nowrap">
          {label}
        </Text>
      </div>
    </Label>
  );
}
